import mix from './mix';

if (Vue) {
    Vue.use(mix);
} else {
    console.log('you must import vue');
}


// WEBPACK FOOTER //
// ./src/main.js